import styled from 'styled-components'

import { palette } from '../../theme/palette'

export const DropdownSelectContainer = styled.div`
  margin: 0 10px 12px;
  position: relative;
  user-select: none;
`

export const DropdownSelectButton = styled.button<{ isSelected: boolean, isDisabled: boolean }>`
  border: 1px solid ${props => props.isDisabled ? palette.disabledElement : palette.mediumGray};
  border-radius: 12px;
  background-color: ${props => props.isDisabled ? palette.disabledElement : palette.white};
  color: ${props => props.isDisabled ? palette.mediumGray : props.isSelected ? palette.mainText : palette.mediumGray};
  padding: 12px 16px;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  
  &:hover {
    cursor: ${props => props.isDisabled ? 'auto' : 'pointer'};
    border-color: ${props => props.isDisabled ? palette.disabledElement : palette.mainText};
  }
  
  &:focus-visible {
    outline: 2px solid ${palette.mainBlue};
  }
`

export const DropdownSelectContent = styled.div<{ isTopPosition: boolean }>`
  box-sizing: border-box;
  position: absolute;
  z-index: 100;
  top: ${props => props.isTopPosition ? 'auto' : '54px'};
  bottom: ${props => props.isTopPosition ? '54px' : 'auto'};
  left: 0;
  right: 0;
  padding:0 4px 0 0;
  max-height: 188px;
  box-shadow: 0 8px 20px rgba(56, 92, 102, 0.08);
  border-radius: 8px;
  background-color: ${palette.white};
  
`

export const DropdownSelectContentContainer = styled.ul`
  box-sizing: border-box;
  max-height: 180px;
  overflow-y: auto;
  margin: 0;
  padding: 0;

  &::-webkit-scrollbar {
    width: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background-color: ${palette.mainText};
    border-radius: 2px;
  }
`

export const DropdownSelectItem = styled.li`
  margin: 0 4px 4px;
  border-radius: 8px;
  position: relative;
  list-style-type: none;
  
  &:first-child {
    margin-top: 4px;
  }
`

export const DropdownSelectItemButton = styled.button.attrs<{ isLoadingIframeData: boolean }>(({ isLoadingIframeData }) => ({
  tabIndex: isLoadingIframeData ? -1 : 0
}))<{ isLoadingIframeData: boolean }>`
  background-color: ${palette.transparent};
  width: 100%;
  border: none;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  padding: 8px 12px;
  text-align: left;
  border-radius: 8px;
  color: ${palette.mainText};
  
  &:hover {
    background-color: ${palette.secondaryHoverState};
    cursor: pointer;
  }
  
  &:focus {
    background-color: ${palette.secondaryFocusState};
    outline: none;
  }

  &:active {
    background-color: ${palette.secondaryClickState};
  }
`
